import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  CHAT_GROUP_BY_COMPONENT,
  CHAT_GROUP_BY_ID,
  GLOBAL_STATE,
  MESSAGES_GROUP,
  MESSAGES_GROUP_ALL,
} from '../constants/actionTypes'

const chatGroupSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const chatGroupByComponentSelector = createSelector(chatGroupSelector, data => data[CHAT_GROUP_BY_COMPONENT])

export const chatGroupByIdSelector = createSelector(chatGroupSelector, data => data[CHAT_GROUP_BY_ID])

export const messagesGroupSelector = createSelector(chatGroupSelector, data => data[MESSAGES_GROUP])

export const messagesGroupAllSelector = createSelector(chatGroupSelector, data => data[MESSAGES_GROUP_ALL])
